<template>
  <v-app>
    <meta name="All github commit numberg" :latest-commit-number="latestCommitNumber">
    <meta name="All github tag" :latest-tag="latestTag ">
    <header-toolbar></header-toolbar>
    <transition name="fade">
      <router-view/>
    </transition>
    <footer-toolbar></footer-toolbar>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.github{
  margin-left: 70%;

  font-size: 15px;
}
.github-tag-font-color{
  font-weight: bold;
}
</style>
<script>
import HeaderToolbar from '@/components/HeaderToolbar.vue'
import FooterToolbar from '@/components/FooterToolbar.vue'
export default {
  name: 'App',
  components: {
    HeaderToolbar,
    FooterToolbar
  },
  data () {
    return {
      latestCommitNumber: '',
      allCommitNumber: '',
      latestTag: '',
      allTag: '',
      isLocalhost8080: '',
      isCloudFront: '',
      production: ''
    }
  },
  created () {
    const selectItems = require('@/file.json')
    console.log(selectItems)
    this.latestCommitNumber = selectItems.commitNumber[0]
    this.latestTag = selectItems.latestTag
    this.allCommitNumber = selectItems.commitNumber
    this.allTag = selectItems.tags
  },
  mounted () {
    const { hostname, port } = window.location
    // ホスト名がlocalhostでポート番号が8080の場合にフラグをtrueに設定
    this.isLocalhost8080 = hostname === 'localhost' && port === '8080'
    this.isCloudFront = hostname === 'd11zsecakzytpn.cloudfront.net'
    this.production = hostname === 'beginners-survey.japan-reit.com'
  }
}
</script>
